import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
// import AddIcon from "@mui/icons-material/Add";
import SearchBar from "../../components/SearchBar";
import SwitchToggle from "../../components/SwitchToggle";
import AddCategory from "../../Modals/addCategory";

const ManageCategories = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [openModal, setOpenModal] = useState(false);

  const categories = [
    { id: 1, name: "Car", subCategories: 6, createdDate: "01-Sept-2025", status: true },
    { id: 2, name: "Bike", subCategories: 4, createdDate: "02-Sept-2025", status: true },
    { id: 3, name: "Bicycle", subCategories: 3, createdDate: "03-Sept-2025", status: true },
    { id: 4, name: "Caravan", subCategories: 2, createdDate: "04-Sept-2025", status: false },
    { id: 5, name: "Trucks", subCategories: 5, createdDate: "05-Sept-2025", status: true },
    { id: 6, name: "Heavy Equipment", subCategories: 4, createdDate: "06-Sept-2025", status: true },
    { id: 7, name: "Spare Parts", subCategories: 8, createdDate: "07-Sept-2025", status: true },
    { id: 8, name: "Car Accessories", subCategories: 10, createdDate: "08-Sept-2025", status: true },
  ];

  return (
    <>
      {/* PAGE TITLE */}
      <div className="main_title">
        <h1>Categories Management</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> –{" "}
          Categories Management
        </p>
      </div>

      <div className="cards">
        {/* TABLE HEADER */}
        <div className="table_header">
          <div className="left_s">
            <SearchBar
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setSearchTerm}
              placeholder="Search..."
            />
          </div>
          <div className="right_s">
            {/* <Button
              className="btn btn_primary"
              onClick={() => setOpenModal(true)}
            >
              <AddIcon /> Add Category
            </Button> */}
          </div>
        </div>

        {/* TABLE */}
        <TableContainer className="table_container">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Sr. No</TableCell>
                <TableCell>Icon</TableCell>
                <TableCell>Category Details</TableCell>
                <TableCell>Sub-Categories</TableCell>
                <TableCell>Created Date</TableCell>
                <TableCell>Enable/Disable</TableCell>
                <TableCell>Popular</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {categories.map((category, index) => (
                <TableRow hover key={category.id}>
                  {/* SR NO */}
                  <TableCell>{index + 1}</TableCell>

                  {/* ICON */}
                  <TableCell>
                    <div className="user_block">
                      <figure className="no_radius">
                        <img src="/static/images/placeholder.png" alt={category.name} />
                      </figure>
                    </div>
                  </TableCell>

                  {/* CATEGORY NAME */}
                  <TableCell>
                    <div className="user_block">
                      <figure className="no_radius">
                        <img src="/static/images/placeholder.png" alt={category.name} />
                      </figure>
                      <p>
                        <b>{category.name}</b>
                      </p>
                    </div>
                  </TableCell>

                  {/* SUB CATEGORIES */}
                  <TableCell>
                    <Button
                      className="btn btn_primary sm"
                      onClick={() =>
                        navigate("/manage-categories/sub-categories")
                      }
                    >
                      View ({category.subCategories})
                    </Button>
                  </TableCell>

                  {/* CREATED DATE */}
                  <TableCell>{category.createdDate}</TableCell>

                  {/* STATUS */}
                  <TableCell>
                    <SwitchToggle defaultChecked={category.status} />
                  </TableCell>
                  
                  <TableCell>
                    <SwitchToggle />
                  </TableCell>

                  {/* ACTIONS */}
                  <TableCell>
                    <div className="table_actions v2">
                      <IconButton onClick={() => setOpenModal(true)}>
                        <img
                          src="/static/images/edit2_icon.svg"
                          alt="Edit"
                        />
                      </IconButton>
                      <IconButton>
                        <img
                          src="/static/images/trash2_icon.svg"
                          alt="Delete"
                        />
                      </IconButton>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>

      {/* ADD / EDIT MODAL */}
      <AddCategory
        open={openModal}
        onClose={() => setOpenModal(false)}
        setOpen={setOpenModal}
      />
    </>
  );
};

export default ManageCategories;
